import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Card, Row, Col, Table, Dropdown, Nav, Button, Modal } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { getToken } from '../services/authorize'
import axiosInstance from "../services/axiosInterceptor";
import Swal from "sweetalert2";
import { useLoading } from '../contexts/LoadingContext';
import { groupTeachingData, getDayNameTHByIndex } from '../utils/teachingUtils'

// การ์ดวิชาที่สอนในห้อง 1 รายการ สำหรับมุมมองมือถือ
const TeachingCard = ({ item, onEdit }) => (
  <div className="border rounded p-3">
    <div className="fw-semibold">{item.sub_subid} {item.sub_subname} {item.sub_type}</div>
    <div className="mt-2 pt-2 border-top fs-sm">
      <div><span className="text-muted">วัน:</span> {item.times && item.times.length > 0
        ? item.times.map((t, i) => <span key={i} className="me-2">{getDayNameTHByIndex(t.teach_day)}</span>)
        : "-"}</div>
      <div><span className="text-muted">คาบ:</span> {item.times && item.times.length > 0
        ? item.times.map((t, i) => <span key={i} className="me-2">{t.period_order}</span>)
        : "-"}</div>
      <div><span className="text-muted">ครูผู้สอน:</span> {item.t_name}</div>
    </div>
    <div className="mt-2 pt-2 border-top">
      <Button variant="primary" size="sm" className="w-100" onClick={onEdit}>
        <i className="ri-edit-box-line me-1"></i>แก้ไข
      </Button>
    </div>
  </div>
)

export default function ManageTeaching() {
  ///// Skin Switch /////
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');
      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }

    // Toggle dark mode for all tables
    const tables = document.getElementsByTagName('table');
    for (const table of tables) {
      const theads = table.querySelectorAll('thead'); // หาทุก thead ภายใน table
      if (skin === 'dark') {
        for (const thead of theads) {
          thead.classList.remove('table-secondary');
          thead.classList.add('table-primary');
        }
        table.classList.add('table-dark');
      } else {
        table.classList.remove('table-dark');
        for (const thead of theads) {
          thead.classList.remove('table-primary');
          thead.classList.add('table-secondary');
        }
      }
    }
  }

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  // const [classId, setClassId] = useState(null);
  const { c_id } = useParams();
  const { setLoading } = useLoading();

  const [data, setData] = useState({})
  const [yearId, setYearId] = useState(() => {
    return localStorage.getItem('yearId') || null;
  })
  const [selectedYear, setSelectedYear] = useState("");
  const [yearList, setYearList] = useState([]);
  const [classList, setClassList] = useState([1]);
  const [show, setShow] = useState(false);
  const [modalMode, setModalMode] = useState("add"); // "add" or "edit"
  const [editTeachId, setEditTeachId] = useState(null);

  // ฟิลด์สำหรับฟอร์ม
  const [formSubjectId, setFormSubjectId] = useState("");
  const [formTeacherId, setFormTeacherId] = useState("");
  const [formDay, setFormDay] = useState("");
  const [formPeriod, setFormPeriod] = useState("");

  useEffect(() => {
    // get yearId from lastest year in database
    axiosInstance.get(`${process.env.REACT_APP_API}/getStudyYear`, {
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        const list = res.data;
        setYearList(list);

        // ถ้า yearId ยังไม่มีใน localStorage ให้ใช้ปีล่าสุด
      let initialYearId = localStorage.getItem('yearId');
        if (!initialYearId && list.length > 0) {
          initialYearId = list[0].year_id;
          localStorage.setItem('yearId', initialYearId);
        }
        setYearId(initialYearId);
        const selected = list.find(y => String(y.year_id) === String(initialYearId));
        setSelectedYear(selected ? `ปีการศึกษา ${selected.year_year}` : "");
      })
      .catch(err => {
        console.log("Error loading years:", err);
      })
      .finally(() => {
        
      })
  }, [])

  useEffect(() => {
    axiosInstance.get(`${process.env.REACT_APP_API}/getClassList`, {
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        setClassList(res.data);
      })
      .catch(err => {
        console.error("Error loading class list:", err);
      });
  }, []);

  // Load teaching data when c_id and yearId change
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [roomList, setRoomList] = useState([]);
  const [roomId, setRoomId] = useState(null);

  const cidActive = c_id || "1";
  const getRoomStorageKey = (classId, year) => `manageTeaching:selectedRoom:${classId}:${year}`;

  useEffect(() => {
    if (cidActive && yearId) {
      setLoading(true);
      setRoomId(null); // Reset roomId when class or year changes
      setSelectedRoom(null); // Reset selected room
      axiosInstance.get(`${process.env.REACT_APP_API}/getRoomListByClassId/${cidActive}/${yearId}`, {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      })
        .then(res => {
          if (res.data.length > 0) {
            // console.log("Room list loaded:", res.data);
            setRoomList(res.data);
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'ไม่พบข้อมูลห้องเรียน',
              text: 'กรุณาเพิ่มห้องเรียนก่อนทำการสอน',
            });
          }
        })
        .catch(err => {
          setRoomList([]);
          console.error("Error loading teaching data:", err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }
  , [cidActive, yearId, setLoading]);

  useEffect(() => {
    if (!cidActive || !yearId || roomList.length === 0) return;

    const storageKey = getRoomStorageKey(cidActive, yearId);
    const savedRoomId = localStorage.getItem(storageKey);
    if (!savedRoomId) return;

    const savedRoom = roomList.find(r => String(r.r_id) === String(savedRoomId));
    if (savedRoom) {
      setRoomId(savedRoom.r_id);
      setSelectedRoom(`ชั้น ม.${savedRoom.tb_class_c_id}/${savedRoom.r_no} ${savedRoom.p_code}`);
    } else {
      localStorage.removeItem(storageKey);
    }
  }, [cidActive, yearId, roomList]);

  // Function to handle dropdown change
  const handleSelectYear = (id) => {
    const selected = yearList.find(y => y.year_id === id);
    if (selected) {
      setYearId(id); // ใช้ id สำหรับ query
      setSelectedYear(`ปีการศึกษา ${selected.year_year}`)
      localStorage.setItem('yearId', id); // Save to localStorage
    }
  }

  // retrieve teaching data when roomId changes
  useEffect(() => {
    if (roomId) {
      setLoading(true);
      axiosInstance.get(`${process.env.REACT_APP_API}/getTeachingDataByRoomId/${roomId}`, {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      })
        .then(res => {
          if (res.data.length > 0) {
            setData(groupTeachingData(res.data))
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'ไม่พบข้อมูลการสอน',
              text: 'กรุณาเพิ่มข้อมูลการสอนก่อน',
            });
            setData([]);
          }
        })
        .catch(err => {
          console.error("Error loading teaching data:", err);
          setData([]);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setData([]); // Clear data if no roomId is selected
    }
  }, [roomId, setLoading]);


  // Function to handle room selection
  const handleSelectRoom = (id) => {
    const selectedRoom = roomList.find(r => r.r_id === id);
    if (selectedRoom) {
      setRoomId(id); // ใช้ id สำหรับ query
      setSelectedRoom(`ชั้น ม.${selectedRoom.tb_class_c_id}/${selectedRoom.r_no} ${selectedRoom.p_code}`); // แสดงชั้นเรียนจริง
      if (cidActive && yearId) {
        localStorage.setItem(getRoomStorageKey(cidActive, yearId), String(id));
      }
    }
  }

  const [teachId, setTeachId] = useState(null);
  const [subjectId, setSubjectId] = useState(null);
  const [selectedSemester, setSelectedSemester] = useState(null); // Default to semester 1
  const [view, setView] = useState(() =>
    (typeof window !== 'undefined' && window.innerWidth < 768) ? 'card' : 'table')
  const [availableSubjects, setAvailableSubjects] = useState([]);
  const [teacherList, setTeacherList] = useState([]);
  const [periodList, setPeriodList] = useState([]);

  useEffect(() => {
    if (!roomId || !selectedSemester) return;
    // Load subject list
    axiosInstance.get(`${process.env.REACT_APP_API}/getSubjectListByRoomIdAndSemester/${roomId}/${selectedSemester}/${yearId}`, {
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        setAvailableSubjects(res.data);
      })
      .catch(err => {
        // console.error("Error loading subject list:", err);
        setAvailableSubjects([]);
      })
      .finally(() => {
       
      })
  }, [roomId, selectedSemester]);

  // Load teacher list
  useEffect(() => {
    axiosInstance.get(`${process.env.REACT_APP_API}/getTeacherList?side=academic`, {
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        setTeacherList(res.data);
      })
      .catch(err => {
        console.error("Error loading teacher list:", err);
      });
  }, [])

  // get period list
  useEffect(() => {
    axiosInstance.get(`${process.env.REACT_APP_API}/getPeriodList/${yearId}`, {
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        // console.log("Period list loaded:", res.data);
        setPeriodList(res.data);
      })
      .catch(err => {
        console.error("Error loading period list:", err);
      });
  }, [yearId]);


  // เปิด modal สำหรับ add/edit
  const handleShow = (mode, teach_id = null) => {
    setModalMode(mode);
    if (mode === "add") {
      setEditTeachId(null);
      setFormSubjectId("");
      setFormTeacherId("");
      setFormDay("");
      setFormPeriod("");
      setTimes([{ teachDay: "", periodId: "" }]); // reset times
    } else if (mode === "edit") {
      setEditTeachId(teach_id);
      const record = data.find(d => String(d.teach_id) === String(teach_id));
      if (record) {
        setFormSubjectId(record.sub_id || "");
        setFormTeacherId(record.t_id || "");
        // setTimes จากข้อมูล times ของ record
        if (Array.isArray(record.times) && record.times.length > 0) {
          // console.log("DEBUG times:", record.times);
          // console.log("DEBUG record:", data);
          setTimes(record.times.map(t => ({
            teachDay: t.teach_day !== undefined && t.teach_day !== null ? String(t.teach_day) : "",
            periodId: t.period_id !== undefined && t.period_id !== null ? String(t.period_id) : ""
          })));
        } else {
          setTimes([{ teachDay: "", periodId: "" }]);
        }
      }
    }
    setShow(true);
  }

  const handleClose = () => {
    setTimes([{ teachDay: "", periodId: "" }]); // Reset times
    setShow(false);
  }


  // เมื่อ modalMode หรือ editTeachId เปลี่ยน ให้ set ค่า input
  useEffect(() => {
    if (modalMode === "edit" && editTeachId) {
      const record = Array.isArray(data) ? data.find(d => d.teach_id === editTeachId) : null;
      if (record) {
        setFormSubjectId(record.sub_id || "");
        setFormTeacherId(record.t_id || "");

        // ถ้า availableSubjects ไม่มีวิชานี้ ให้เพิ่มเข้าไป (เฉพาะตอนแก้ไข)
        if (availableSubjects.every(sub => String(sub.sub_id) !== String(record.sub_id))) {
          setAvailableSubjects(prev => [
            ...prev,
            {
              sub_id: record.sub_id,
              sub_subid: record.sub_subid,
              sub_subname: record.sub_subname,
              sub_type: record.sub_type,
              // เพิ่ม field อื่นๆ ตามที่ต้องใช้
            }
          ])
        }
      }
    }
    if (modalMode === "add") {
      setFormSubjectId("");
      setFormTeacherId("");
    }
  }, [modalMode, editTeachId, data]);

  // ฟังก์ชันบันทึก
  const handleSaveTeaching = () => {
    // Validate...
    if (!formSubjectId || !formTeacherId) {
      Swal.fire({
        icon: 'warning',
        title: 'ข้อมูลไม่ครบถ้วน',
        text: "กรุณาระบุวิชา และครูผู้สอน"
      })
      return;
    }
    setLoading(true);
    if (modalMode === "add") {
      setLoading(true);
      // POST ไปยัง backend เพื่อเพิ่ม
      const newTeaching = {
        subjectId: formSubjectId,
        teacherId: formTeacherId,
        roomId: roomId,
        times // array ของ { teachDay, periodId }
      }
      axiosInstance.post(`${process.env.REACT_APP_API}/assignTeaching`, newTeaching, {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      })
      .then(res => {
        Swal.fire({
          icon: 'success',
          title: 'บันทึกสำเร็จ',
          text: 'ข้อมูลการสอนได้ถูกบันทึกเรียบร้อยแล้ว'
        });
        // console.log("Old teaching data:", data);
        // console.log("Teaching data saved successfully:", res.data);
        setData(prev => [...prev, ...groupTeachingData(res.data.newData)]); // เพิ่มข้อมูลใหม่เข้าไปใน state
      })
      .catch(err => {
        console.error("Error saving teaching data:", err);
        Swal.fire({
          icon: 'error',
          title: err.response?.data?.message || 'เกิดข้อผิดพลาด',
          text: err.response?.data?.message || 'ไม่สามารถบันทึกข้อมูลได้'
        });
      })      
    } else if (modalMode === "edit") {
      // POST ไปยัง backend เพื่อแก้ไข
      const updatedTeaching = {
        teachId: editTeachId,
        teacherId: formTeacherId,
        times, // array ของ { teachDay, periodId }
      }
      axiosInstance.post(`${process.env.REACT_APP_API}/updateTeaching`, updatedTeaching, {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      })
      .then(res => {
        Swal.fire({
          icon: 'success',
          title: 'บันทึกสำเร็จ',
          text: 'ข้อมูลการสอนได้ถูกแก้ไขเรียบร้อยแล้ว'
        });
        setData(prev =>
          prev.map(d =>
            d.teach_id === editTeachId
              ? groupTeachingData(Array.isArray(res.data.updatedData) ? res.data.updatedData : [res.data.updatedData])[0]
              : d
          )
        )
      })
      .catch(err => {
        console.error("Error updating teaching data:", err);
        Swal.fire({
          icon: 'error',
          title: err.response?.data?.message || 'เกิดข้อผิดพลาด',
          text: err.response?.data?.message || 'ไม่สามารถแก้ไขข้อมูลได้'
        });
      });

    }
    setTimes([{ teachDay: "", periodId: "" }]); // Reset times
    setShow(false);
    setLoading(false);
  }

  const [times, setTimes] = useState([{ teachDay: "", periodId: "" }]);

  const addTime = () => setTimes([...times, { teachDay: "", periodId: "" }]);
  const removeTime = idx => setTimes(times.filter((_, i) => i !== idx));
  const updateTime = (idx, field, value) => {
    setTimes(times.map((t, i) => i === idx ? { ...t, [field]: value } : t));
  };

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link to="#">ข้อมูลการเรียนการสอน</Link></li>
              <li className="breadcrumb-item active" aria-current="page">จัดการการสอน</li>
            </ol>
            <h4 className="main-title mb-0">จัดการการสอน</h4>
          </div>
          <div className="d-flex align-items-center gap-2 mt-3 mt-md-0">
            <Dropdown>
              <Dropdown.Toggle variant="primary" id="dropdown-basic">
                {selectedYear || "เลือกปีการศึกษา"}
              </Dropdown.Toggle>
              <Dropdown.Menu>
              {yearList.map(item => (
                <Dropdown.Item key={item.year_id} onClick={() => handleSelectYear(item.year_id)}>
                  ปีการศึกษา {item.year_year}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <Row className="g-12 mb-4">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <Nav variant="tabs" defaultActiveKey={`/teaching/manage-teaching/${cidActive}`}>
              {classList.map((cls, index) => (
                <Nav.Item key={cls.c_id + '-' + index}>
                  <Nav.Link
                    as={Link}
                    to={`/teaching/manage-teaching/${cls.c_id}`}
                    active={String(cidActive) === String(cls.c_id)}
                  >
                    {cls.c_class}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>
          <Card className="card-one">
            <Card.Header className="d-flex flex-wrap justify-content-between align-items-center gap-2">
              <Card.Title as="h6" className="mb-0">{selectedYear}</Card.Title>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <span className="text-muted">ชั้นเรียน:</span>
                <Dropdown>
                  <Dropdown.Toggle variant="primary" id="dropdown-basic">
                    {selectedRoom || "เลือกชั้นเรียน"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {roomList.map(item => (
                      <Dropdown.Item key={item.r_id} onClick={() => handleSelectRoom(item.r_id)}>
                        ม. {item.tb_class_c_id}/{item.r_no} ({item.p_code})
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
                {roomId && (
                  <div className="btn-group btn-group-sm" role="group" aria-label="สลับมุมมอง">
                    <button type="button" className={`btn btn${view === 'table' ? '' : '-outline'}-primary`}
                      onClick={() => setView('table')} title="มุมมองตาราง">
                      <i className="ri-table-line" />
                    </button>
                    <button type="button" className={`btn btn${view === 'card' ? '' : '-outline'}-primary`}
                      onClick={() => setView('card')} title="มุมมองการ์ด">
                      <i className="ri-layout-grid-line" />
                    </button>
                  </div>
                )}
              </div>
            </Card.Header>
            <Card.Body className="p-3">
              { !roomId ? (
                <div className="text-center my-3">
                  <span className="text-muted">กรุณาเลือกชั้นเรียนก่อน</span>
                </div>
              ) : view === 'card' ? (
                <>
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <h6 className="mb-0">ภาคเรียนที่ 1</h6>
                    <Button variant="success" size="sm" onClick={() => handleShow("add", setSelectedSemester("1"))}>
                      <i className="ri-add-box-line"></i> เพิ่ม
                    </Button>
                  </div>
                  <Row className="g-3 mb-4">
                    {data && data.length > 0 && data.some(d => d.sub_semester === '1') ? (
                      data.filter(d => d.sub_semester === '1').map(item => (
                        <Col key={item.teach_id} xs={12} md={6} xl={4}>
                          <TeachingCard item={item} onEdit={() => handleShow("edit", item.teach_id)} />
                        </Col>
                      ))
                    ) : (
                      <Col xs={12}><div className="text-center text-muted py-3">ไม่พบข้อมูล</div></Col>
                    )}
                  </Row>
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <h6 className="mb-0">ภาคเรียนที่ 2</h6>
                    <Button variant="success" size="sm" onClick={() => handleShow("add", setSelectedSemester("2"))}>
                      <i className="ri-add-box-line"></i> เพิ่ม
                    </Button>
                  </div>
                  <Row className="g-3">
                    {data && data.length > 0 && data.some(d => d.sub_semester === '2') ? (
                      data.filter(d => d.sub_semester === '2').map(item => (
                        <Col key={item.teach_id} xs={12} md={6} xl={4}>
                          <TeachingCard item={item} onEdit={() => handleShow("edit", item.teach_id)} />
                        </Col>
                      ))
                    ) : (
                      <Col xs={12}><div className="text-center text-muted py-3">ไม่พบข้อมูล</div></Col>
                    )}
                  </Row>
                </>
              ) : (
              <Table responsive bordered striped hover className="mb-0">
                <thead>
                  <tr className="text-center">
                    <th scope="row" colSpan={6}>ภาคเรียนที่ 1</th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th scope="col" className="text-center" style={{ width: "80px" }}>รหัสวิชา</th>
                    <th scope="col" className="text-center">ชื่อวิชา</th>
                    <th scope="col" className="text-center" style={{ width: "70px" }}>วัน</th>
                    <th scope="col" className="text-center" style={{ width: "50px" }}>คาบ</th>
                    <th scope="col" className="text-center">ครูผู้สอน</th>
                    <th scope="col" className="text-center" style={{ width: "90px" }}>
                      <Button variant="success" size="sm" className="btn-xs" onClick={() => handleShow("add", setSelectedSemester("1"))}>
                        <i className="ri-add-box-line"></i> เพิ่ม
                      </Button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data && data.length > 0 && data.some(d => d.sub_semester === '1') ? (
                    data
                      .filter(d => d.sub_semester === '1')
                      .map((data, index) => (
                        <tr key={data.teach_id}>
                          <th scope="row" className="text-center">{data.sub_subid}</th>
                          <td className="text-center">{data.sub_subname + ' ' + data.sub_type}</td>
                          <td className="text-center">
                            {data.times && data.times.length > 0
                              ? data.times.map((t, i) =>
                                  <div key={i}>{getDayNameTHByIndex(t.teach_day)}</div>
                                )
                              : "-"}
                          </td>
                          <td className="text-center">
                            {data.times && data.times.length > 0
                              ? data.times.map((t, i) =>
                                  <div key={i}>{t.period_order}</div>
                                )
                              : "-"}
                          </td>
                          <td className="text-center">{data.t_name}</td>
                          <td className="text-center">
                            <Button variant="primary" size="sm" className="btn-xs" onClick={() => handleShow("edit", data.teach_id)}>
                              <i className="ri-add-box-line"></i> แก้ไข
                            </Button>
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-center">ไม่พบข้อมูล</td>
                    </tr>
                  )}
                </tbody>
                <thead>
                  <tr className="text-center">
                    <th scope="row" colSpan={6}>ภาคเรียนที่ 2</th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th scope="col" className="text-center" style={{ width: "80px" }}>รหัสวิชา</th>
                    <th scope="col" className="text-center">ชื่อวิชา</th>
                    <th scope="col" className="text-center" style={{ width: "70px" }}>วัน</th>
                    <th scope="col" className="text-center" style={{ width: "50px" }}>คาบ</th>
                    <th scope="col" className="text-center">ครูผู้สอน</th>
                    <th scope="col" className="text-center" style={{ width: "90px" }}>
                      <Button variant="success" size="sm" className="btn-xs" onClick={() => handleShow("add", setSelectedSemester("2"))}>
                        <i className="ri-add-box-line"></i> เพิ่ม
                      </Button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data && data.length > 0 && data.some(d => d.sub_semester === '2') ? (
                    data
                      .filter(d => d.sub_semester === '2')
                      .map((data, index) => (
                        <tr key={data.teach_id}>
                          <th scope="row" className="text-center">{data.sub_subid}</th>
                          <td className="text-center">{data.sub_subname + ' ' + data.sub_type}</td>
                          <td className="text-center">
                            {data.times && data.times.length > 0
                              ? data.times.map((t, i) =>
                                  <div key={i}>{getDayNameTHByIndex(t.teach_day)}</div>
                                )
                              : "-"}
                          </td>
                          <td className="text-center">
                            {data.times && data.times.length > 0
                              ? data.times.map((t, i) =>
                                  <div key={i}>{t.period_order}</div>
                                )
                              : "-"}
                          </td>
                          <td className="text-center">{data.t_name}</td>
                          <td className="text-center">
                            <Button variant="primary" size="sm" className="btn-xs" onClick={() => handleShow("edit", data.teach_id)}>
                              <i className="ri-add-box-line"></i> แก้ไข
                            </Button>
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-center">ไม่พบข้อมูล</td>
                    </tr>
                  )}
                </tbody>
              </Table>
              )}
            </Card.Body>
          </Card>
        </Row>
        <Footer />
      </div>

      <Modal show={show} onHide={handleClose} size="sm">
        <Modal.Header closeButton>
          <Modal.Title>
            {modalMode === "add" ? "เพิ่มข้อมูลการสอน" : "แก้ไขข้อมูลการสอน"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={e => e.preventDefault()}>
            <div className="mb-3">
              <label className="form-label">วิชา</label>
              <select className="form-select"
                value={String(formSubjectId)}
                onChange={e => setFormSubjectId(e.target.value)}
                disabled={modalMode === "edit"}
              >
                <option value="">-- เลือกวิชา --</option>
                {availableSubjects.map(sub => (
                  <option key={sub.sub_id} value={String(sub.sub_id)}>{sub.sub_subid + ' ' + sub.sub_subname + ' ' + sub.sub_type}</option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">ครูผู้สอน</label>
              <select className="form-select" value={String(formTeacherId)} onChange={e => setFormTeacherId(e.target.value)}>
                <option value="">-- เลือกครูผู้สอน --</option>
                {teacherList.map(teacher => (
                  <option key={teacher.t_id} value={String(teacher.t_id)}>{teacher.t_name}</option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              {times.map((time, idx) => (
                <div key={idx} className="row g-2 mb-2 align-items-center">
                  <div className="col-5">
                    <select className="form-select"
                      value={String(time.teachDay)}
                      onChange={e => updateTime(idx, "teachDay", e.target.value)}
                    >
                      <option value="">-- วัน --</option>
                      <option value="0">อาทิตย์</option>
                      <option value="1">จันทร์</option>
                      <option value="2">อังคาร</option>
                      <option value="3">พุธ</option>
                      <option value="4">พฤหัสบดี</option>
                      <option value="5">ศุกร์</option>
                      <option value="6">เสาร์</option>
                    </select>
                  </div>
                  <div className="col-5">
                    <select className="form-select"
                      value={String(time.periodId)}
                      onChange={e => updateTime(idx, "periodId", e.target.value)}
                    >
                      <option value="">-- คาบ --</option>
                      {periodList.map(period => (
                        <option key={period.period_id} value={String(period.period_id)}>
                          {period.period_order} ({period.period_begin} - {period.period_end})
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-2 d-flex justify-content-end">
                    {times.length > 1 && (
                      <Button variant="danger" size="sm" onClick={() => removeTime(idx)}>ลบ</Button>
                    )}
                  </div>
                </div>
              ))}
              <Button variant="outline-primary" size="sm" onClick={addTime}>+ เพิ่มวัน/คาบ</Button>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>ปิด</Button>
          <Button variant="success" onClick={handleSaveTeaching}>
            {modalMode === "add" ? "บันทึก" : "บันทึกการแก้ไข"}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  )
}